import script from "./ServiceDetailsDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceDetailsDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceDetailsDrawer.vue?vue&type=style&index=0&id=2072d78c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2072d78c"]])

export default __exports__